import * as React from 'react';

import devNote from '@xing-com/dev-note';
import { cornerRadiusS } from '@xing-com/tokens';

import * as Styled from './skeleton-image.styles';
import type { SkeletonImageProps } from './skeleton-image.types';

export const SkeletonImage = React.forwardRef<
  HTMLDivElement,
  SkeletonImageProps
>(
  (
    { className, height = '100%', variant, width = '100%', ...props },
    forwardedRef
  ): JSX.Element => {
    if (variant) {
      devNote.deprecate(
        "The variant property is deprecated and should be removed. Variant 'secondary' is automatically mapped to 'primary'."
      );
    }

    return (
      <Styled.Image
        $height={height}
        $variant={variant}
        $width={width}
        className={className}
        cornerRadius={cornerRadiusS}
        data-xds="SkeletonImage"
        ref={forwardedRef}
        {...props}
      />
    );
  }
);

SkeletonImage.displayName = 'SkeletonImage';
